import { Outlet } from "react-router-dom";

import useWindowSize from "utils/hooks/useWindowSize";
import useScrollToTop from "utils/hooks/useScrollToTop";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "services/redux/store";

const RootLayout = () => {
    // add mode by redux

    const mode = useSelector((state: RootState) => state.site.mode);

    const [windowSize] = useWindowSize();
    useScrollToTop();

    return (
        <div
            className={`App ${mode}  ${
                windowSize >= 992 ? "lgView" : "smView"
            }`}
        >
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
                // theme={mode}
                // transition:"Bounce"
            />
            <Outlet />
        </div>
    );
};

export default RootLayout;
